const TOKEN_KEY = 'sa_brand_token';

export function getBrandToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}
export function setBrandToken(t: string): void {
  try {
    window.localStorage.setItem(TOKEN_KEY, t);
  } catch {
    /* private mode */
  }
}
export function clearBrandToken(): void {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* private mode */
  }
}
